'use strict';
(function () {
  var _controller = 'nps.controller';
  angular.module('pentaApp').controller(_controller, controller);
  controller.$inject = ['$scope', 'inqueryLog.resource'];
  function controller($scope, inqueryLogResource) {
    /// METHODS
    $scope.save = save;

    /// VARS
    $scope.profile = profile;
    $scope.ratingConfig = {
      rating: {
        max: 5,
        multiplier: 2
      }
    }

    /// Se lo llama con {router: id, origin: 'STORE', order: id_order_o_turn_etc, employee: id}
    $scope.inqueryLog = appNavigator.topPage.data;
    var onClose = appNavigator.topPage.data.onClose;
    var onResponse = appNavigator.topPage.data.onResponse;
    delete appNavigator.topPage.data.onClose;
    delete appNavigator.topPage.data.onResponse;
    $scope.inqueryLog.onClose = undefined;

    // WATCHERS
    $scope.$on('$destroy', onDestroy);

    // INIT
    init();
    /////////////////////

    function init() {
      inqueryLogResource.get({ order: $scope.inqueryLog.order, reservation: $scope.inqueryLog.reservation }, function (data) {
        if (data && data._id) { $scope.inqueryLog = data; $scope.responded = true; }
      })
    }


    function save() {
      inqueryLogResource.save($scope.inqueryLog, function () {
        ons.notification.alert({ message: i18next.t('Muchas gracias por ayudarnos'), title: i18next.t('Listo') }).then(function () {
          appNavigator.popPage({
            callback: function () {
              if (onClose) onClose();
              if (onResponse) onResponse();
            }
          });
        })
      })
    }


    function onDestroy() {
      $scope.$root.abortRequests(_controller);
    }
  }

})();
